export class MarkAsDirty {
    static readonly type = '[Editor.Draw] Mark as Dirty';
}

export class OpenBrushControls {
    static readonly type = '[Editor.Draw] Open Brush Controls';
}

export class CloseBrushControls {
    static readonly type = '[Editor.Draw] Close Brush Controls';
}

